import { render, staticRenderFns } from "./topNavbar.vue?vue&type=template&id=148420f4&scoped=true&"
import script from "./topNavbar.vue?vue&type=script&lang=js&"
export * from "./topNavbar.vue?vue&type=script&lang=js&"
import style0 from "./topNavbar.vue?vue&type=style&index=0&id=148420f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148420f4",
  null
  
)

export default component.exports